export enum DataLayerFormName {
  DisableNotifications = 'DisableNotifications',
}
